function initMobileMenu(data, container) {
  const menuMap = {};
  data.forEach(item => {
    if (!menuMap[item.parent]) menuMap[item.parent] = [];
    menuMap[item.parent].push(item);
  });

  const history = [];

  function renderMenu(parentId) {
    container.innerHTML = '';

    if (history.length > 0) {
      const backBtn = document.createElement('div');
      backBtn.className = 'back-button';
      backBtn.textContent = '← Tillbaka';
      backBtn.style.cursor = 'pointer';
      backBtn.style.padding = '10px 15px';
      backBtn.addEventListener('click', () => {
        renderMenu(history.pop());
      });
      container.appendChild(backBtn);
    }

    const ul = document.createElement('ul');
    const items = menuMap[parentId] || [];

    items.forEach(item => {
      const li = document.createElement('li');
      const hasChildren = menuMap[item.id];

      const row = document.createElement('div');
      row.style.display = 'flex';
      row.style.alignItems = 'center';
      row.style.justifyContent = 'space-between';
      row.style.gap = '0.5rem';
      row.style.padding = '10px 15px';

      const drillBtn = document.createElement('button');
      drillBtn.textContent = item.name;
      drillBtn.style.all = 'unset';
      drillBtn.style.cursor = 'pointer';
      drillBtn.style.display = 'block';
      drillBtn.style.flex = '1';
      drillBtn.style.textAlign = 'left';

      if (hasChildren) {
        drillBtn.addEventListener('click', () => {
          history.push(parentId);
          renderMenu(item.id);
        });
      } else {
        drillBtn.addEventListener('click', () => {
          window.location.href = "/collections/all/" + encodeURIComponent(item.slug);
        });
      }

      row.appendChild(drillBtn);

      // 🔹 Sekundär knapp "Visa alla" för noder med barn
      if (hasChildren) {
        const viewAll = document.createElement('a');
        viewAll.textContent = 'Visa alla';
        viewAll.href = "/collections/all/" + encodeURIComponent(item.slug);
        viewAll.style.textDecoration = 'underline';
        viewAll.style.cursor = 'pointer';
        row.appendChild(viewAll);
      }

      li.appendChild(row);
      ul.appendChild(li);
    });

    container.appendChild(ul);
  }

  renderMenu(1); // Start från parent: 1 (Produkter)
}

document.addEventListener('DOMContentLoaded', () => {
  const details = document.getElementById('Details-menu-drawer-container');

  if (!details) return;

  details.addEventListener('toggle', () => {
    const container = document.getElementById('dynamic-menu-mobile');
    if (details.open && container && container.innerHTML.trim() === '') {
      fetch('{{ "menu_structure.json" | asset_url }}')
        .then(response => {
          if (!response.ok) throw new Error('Menu JSON not found');
          return response.json();
        })
        .then(data => {
          const filteredData = data.filter(category => category.product_count > 0);
          initMobileMenu(filteredData, container);
        })
        .catch(error => {
          console.error("Kunde inte ladda menyfil:", error);
        });
    }
  });
});
